import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setProductCardView } from '../../actions/lister-actions';
import useCardView from '../../hooks/useCardView';
import TRANSLATIONS from '../../translations/translations@default.json';
import { cookie } from '../../utilities/lister-utilities';

export const ViewControls = () => {
	const { isDealsPage } = useSelector((state) => state);

	const { isGridView, isListView } = useCardView();

	const dispatch = useDispatch();

	const handleViewSwitch = (viewType) => {
		cookie(isDealsPage ? 'DealsViewFormat' : 'ListerViewFormat').set(
			viewType,
			30
		);
		dispatch(setProductCardView(viewType));
	};

	return (
		<React.Fragment>
			<span className="text-title-sm text-sm hidden lg:inline mr-2">
				{TRANSLATIONS.controls.viewControls.view}
			</span>
			<button
				type="button"
				className={classnames(
					'cta cta-secondary btn btn-secondary text-xs inline-flex items-center rounded bg-white my-2 mr-2 font-body',
					{
						'text-water border-gray-30 bg-white font-body': isGridView,
					}
				)}
				onClick={() => handleViewSwitch('list')}
				data-testid="view-control-list">
				<i className="ico ico-list mr-2 text-lg leading-none" />
				{TRANSLATIONS.controls.viewControls.listViewButton}
			</button>
			<button
				type="button"
				className={classnames(
					'cta cta-secondary btn btn-secondary text-xs inline-flex items-center rounded bg-white font-body',
					{
						'text-water border-gray-30 bg-white font-body': isListView,
					}
				)}
				onClick={() => handleViewSwitch('grid')}
				data-testid="view-control-grid">
				<i className="ico ico-grid mr-2 text-lg leading-none" />
				{TRANSLATIONS.controls.viewControls.gridViewButton}
			</button>
		</React.Fragment>
	);
};

export default ViewControls;
